var map = {
	"./033-bm.webp": 1227,
	"./033-cn.webp": 1228,
	"./033.webp": 1229,
	"./13-bm.webp": 1230,
	"./13-cn.webp": 1231,
	"./13.webp": 1232,
	"./3-bm.webp": 1233,
	"./3-cn.webp": 1234,
	"./3.webp": 1235,
	"./angpao-bg-mobile.jpg": 1236,
	"./angpao-bg.jpg": 1237,
	"./angpao-bm.webp": 1238,
	"./angpao-cn.webp": 1239,
	"./angpao.webp": 1240,
	"./button.png": 1241,
	"./close-eye.png": 1242,
	"./coin-1.png": 1243,
	"./coin.png": 1244,
	"./ketupak-open.png": 1245,
	"./ketupak.png": 1246,
	"./ketupak_ribbon.png": 1247,
	"./rain-1.png": 1248,
	"./rain-2.png": 1249,
	"./rain-3.png": 1250,
	"./raya-bg-mobile.png": 1251,
	"./raya-bg.png": 1252,
	"./shine.png": 1253,
	"./star-1.png": 1254,
	"./star-2.png": 1255
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 458;